/* ESLint errors suppressed for #4183 */
/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from 'styles/components/productdetail/stylePickerDropdown.scss';

const ColorChooser = ({ selectedStyle, styleList, onColorChange, showStyleChooserPrefix, showColorLabel = true, isGiftCard }, { testId }) => {
  const colorName = (selectedStyle || {}).color;
  const colorLabel = isGiftCard ? 'Gift Amount' : 'Color';
  return (
    <div className={styles.styleChooserSection}>
      {showColorLabel && <label htmlFor="pdp-color-select" className={cn({ [styles.singleVal]: styleList.length <= 1 })} data-test-id={testId('color-dropdown-label')}>{colorLabel}</label>}
      {styleList.length > 1 ? (
        <div className={styles.styleChooserControlWrapper}>
          <select
            id="pdp-color-select"
            className={cn(styles.styleChooserControl, { [styles.giftCard]: isGiftCard })}
            value={selectedStyle && selectedStyle.styleId}
            onChange={onColorChange}
            data-test-id={testId('pdp-color')}>
            {styleList.map(({ styleId, color }) => <option key={styleId} value={styleId}>{color}</option>)}
          </select>
        </div>
      ) : (
        <div className={styles.styleChooserText} data-test-id={testId('pdp-color')}>
          {showStyleChooserPrefix && <span className={styles.dimensionLabel}>Color: </span>}
          {colorName}
        </div>
      )
      }
      <meta itemProp="color" content={colorName} />
    </div>
  );
};

ColorChooser.contextTypes = {
  testId: PropTypes.func
};

ColorChooser.propTypes = {
  styleList: PropTypes.array,
  selectedStyle: PropTypes.object,
  onColorChange: PropTypes.func,
  showSizingPrefix: PropTypes.bool,
  showColorLabel: PropTypes.bool
};

export default ColorChooser;
/* eslint-enable */
